
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import Media from '@ecl/website-components/Media/Media';
import MediaRatio from '@ecl/website-components/Media/MediaRatio';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Examples display media using `}<inlineCode parentName="p">{`img`}</inlineCode>{` tag on the left and
`}<inlineCode parentName="p">{`background-image`}</inlineCode>{` on the right.`}</p>
    <h2>{`Media sizes`}</h2>
    <Playground system="ec" selectedKind="utilities-media" selectedStory="custom" mdxType="Playground">
  <Media type="a" token="s" mdxType="Media" />
  <Media type="a" token="m" mdxType="Media" />
    </Playground>
    <h2>{`Horizontal size only`}</h2>
    <Playground system="ec" selectedKind="utilities-media" selectedStory="custom" mdxType="Playground">
  <Media type="h" token="s" mdxType="Media" />
  <Media type="h" token="m" mdxType="Media" />
    </Playground>
    <h2>{`Vertical size only`}</h2>
    <Playground system="ec" selectedKind="utilities-media" selectedStory="custom" mdxType="Playground">
  <Media type="v" token="s" mdxType="Media" />
  <Media type="v" token="m" mdxType="Media" />
    </Playground>
    <h2>{`Responsive size`}</h2>
    <p>{`Add the breakpoint before media size to display it only with corresponding screen size (works for all kind of size ahead).`}</p>
    <p>{`Examples:`}</p>
    <ul>
      <li parentName="ul">{`media `}<inlineCode parentName="li">{`m`}</inlineCode>{` on screen size >= breakpoint `}<inlineCode parentName="li">{`md`}</inlineCode>{`, and `}<inlineCode parentName="li">{`s`}</inlineCode>{` otherwise:`}<br parentName="li"></br>
        <inlineCode parentName="li">{`ecl-u-media-a-s ecl-u-media-a-md-m`}</inlineCode></li>
      <li parentName="ul">{`horizontal size `}<inlineCode parentName="li">{`m`}</inlineCode>{` on screen size >= breakpoint `}<inlineCode parentName="li">{`lg`}</inlineCode>{`, and `}<inlineCode parentName="li">{`s`}</inlineCode>{` otherwise:`}<br parentName="li"></br>
        <inlineCode parentName="li">{`ecl-u-media-h-s ecl-u-media-h-lg-m`}</inlineCode></li>
    </ul>
    <h2>{`Ratio`}</h2>
    <p>{`To set ratio of an image, wrap it with a ratio class and add class `}<inlineCode parentName="p">{`ecl-u-media-content`}</inlineCode>{` to the image.`}<br parentName="p"></br>{`
`}{`The width has to be set using media utilities ahead.`}</p>
    <p><strong parentName="p">{`Important:`}</strong>{` when using ratio, media size and margin/padding have to be put on the ratio wrapper, not on the media itself.`}</p>
    <Playground system="ec" selectedKind="utilities-media" selectedStory="custom" mdxType="Playground">
  <MediaRatio type="h" token="m" ratio="16-9" mdxType="MediaRatio" />
  <MediaRatio type="h" token="m" ratio="4-3" mdxType="MediaRatio" />
  <MediaRatio type="h" token="m" ratio="3-2" mdxType="MediaRatio" />
  <MediaRatio type="h" token="m" ratio="1-1" mdxType="MediaRatio" />
    </Playground>
    <h2>{`Background image`}</h2>
    <p>{`There are several classes that can be used to manage how the background image is displayed.`}<br parentName="p"></br>{`
`}{`CSS properties that can be altered are:`}</p>
    <ul>
      <li parentName="ul">{`background-origin`}</li>
      <li parentName="ul">{`background-position`}</li>
      <li parentName="ul">{`background-repeat`}</li>
      <li parentName="ul">{`background-size`}</li>
    </ul>
    <p>{`Check the playground to see possible combinations.`}<br parentName="p"></br>{`
`}{`Here are some examples:`}</p>
    <Playground system="ec" selectedKind="utilities-media" selectedStory="custom" mdxType="Playground">
  <div className="demo-media-bg ecl-u-media-a-m ecl-u-media-bg-position-center" />
  <span className="ecl-u-type-m">ecl-u-media-bg-position-center</span>
  <div className="demo-media-bg ecl-u-media-a-m ecl-u-media-bg-repeat-none ecl-u-media-bg-size-contain" />
  <span className="ecl-u-type-m">
    ecl-u-media-bg-repeat-none, ecl-u-media-bg-size-contain
  </span>
  <div className="demo-media-bg ecl-u-media-a-m ecl-u-media-bg-position-center ecl-u-media-bg-repeat-none ecl-u-media-bg-size-cover" />
  <span className="ecl-u-type-m">
    ecl-u-media-bg-position-center, ecl-u-media-bg-repeat-none,
    ecl-u-media-bg-size-cover
  </span>
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;